module.exports = __webpack_public_path__ + "static/media/dark.b753479c.png";